var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C10.322 46 0 35.678 0 23C0 10.322 10.322 0 23 0C35.678 0 46 10.322 46 23C46 35.678 35.678 46 23 46ZM23 2.2439C11.5561 2.2439 2.2439 11.5561 2.2439 23C2.2439 34.4439 11.5561 43.7561 23 43.7561C34.4439 43.7561 43.7561 34.4439 43.7561 23C43.7561 11.5561 34.4439 2.2439 23 2.2439Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6734 30.931C20.3808 30.931 20.0882 30.8133 19.8542 30.5779L12.2476 22.9271C11.7795 22.4563 11.7795 21.7501 12.2476 21.2793C12.7157 20.8084 13.4178 20.8084 13.8859 21.2793L20.6149 28.0473L32.0833 15.4529C32.4929 14.9821 33.2536 14.9232 33.7217 15.394C34.1898 15.806 34.2483 16.5711 33.7802 17.0419L21.4925 30.5779C21.317 30.8133 21.0244 30.931 20.6734 30.931Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedIcon);
export default __webpack_public_path__ + "static/media/confirmed-icon.67a911d49bd4ba53343382c99aab622c.svg";
export { ForwardRef as ReactComponent };